// @flow strict

import * as React from 'react';
import { uuid } from '@ta/common.string';
import type { TripsEventSession } from './interactions';

export type SaveSessionContext = {|
  ...TripsEventSession,
  incrementOrder: () => void,
  resetSession: () => void,
|};

const initialContext: SaveSessionContext = {
  sessionUuid: uuid(),
  sessionOrder: 0,
  incrementOrder: () => {},
  resetSession: () => {},
};

const SaveSessionTrackingContext: React.Context<SaveSessionContext> = React.createContext(
  initialContext,
);

export default SaveSessionTrackingContext;
